@import "styles/variables";

.price-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 40px 0;
  position: relative;
}
.col {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 40px;
}
.col label {
  margin-right: 6px;
}
.no-error {
  display: none;
}
.has-error {
  display: block;
}
.error {
  border-radius: 4px;
  font-family: var(--font-stack-default);
  font-weight: normal;
  font-size: 14px;
  box-sizing: border-box;
  position: absolute;
  background: #F67676;
  width: 150px;
  height: 43px;
  right: -95px;
  bottom: -9px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.error div {
  position: absolute;
  left: -10px;
  top: 15px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 10px 6px 0;
  border-color: transparent #F67676 transparent transparent;
}
